import {Status} from "../client/enum";

export enum CampaignStatus {
  NOT_STARTED = 1,
  COLLECTING_DONATIONS = 2,
  FINISHED = 3,
  COMPLETED = 4
}

export enum PeriodicType {
  PER_DAY = 1,
  PER_WEEK = 2,
  PER_MONTH = 3,
  PER_YEAR = 4
}

export enum DonationGoal {
  CHARITY = 1,
  ZAKAT = 2,
  ENDOWMENTS = 3,
  EXPIATION = 4
}

// Helper functions to get enum names by value
export const getCampaignStatusName = (status: number): string => {
  switch (status) {
    case CampaignStatus.NOT_STARTED:
      return 'not_started';
    case CampaignStatus.COLLECTING_DONATIONS:
      return 'collecting_donations';
    case CampaignStatus.FINISHED:
      return 'finished';
    case CampaignStatus.COMPLETED:
      return 'completed';
    default:
      return 'unknown';
  }
};

export const getPeriodicTypeName = (type: number): string => {
  switch (type) {
    case PeriodicType.PER_DAY:
      return 'Per Day';
    case PeriodicType.PER_WEEK:
      return 'Per Week';
    case PeriodicType.PER_MONTH:
      return 'Per Month';
    case PeriodicType.PER_YEAR:
      return 'Per Year';
    default:
      return 'Unknown';
  }
};

export const getDonationGoalName = (goal: number): string => {
  switch (goal) {
    case DonationGoal.CHARITY:
      return 'Charity';
    case DonationGoal.ZAKAT:
      return 'Zakat';
    case DonationGoal.ENDOWMENTS:
      return 'Endowments';
    case DonationGoal.EXPIATION:
      return 'Expiation';
    default:
      return 'Unknown';
  }
};

export const getColor = (type: number): string => {
  switch (type) {
    case PeriodicType.PER_DAY:
      return "green";
    case PeriodicType.PER_WEEK:
      return "blue";
    case PeriodicType.PER_MONTH:
      return "orange";
    case PeriodicType.PER_YEAR:
      return "pink";
    default:
      return "red";
  }
};